const config = {
    URL: "https://api.starlinks.io",
};

export default config;